import api from '../axios';

/**
 * Serviço para dados de tarifas
 */
class TarifasService {
  /**
   * Obtém dados de tarifas para uma data específica
   * @param {string} dataRef - Data de referência (formato: YYYY-MM-DDTHH:mm:ss)
   * @returns {Promise} Response da API com dados de tarifas
   */
  async getTarifas(dataRef) {
    try {
      const response = await api.get('/api/tarifas', {
        params: {
          DataRef: dataRef
        }
      });
      return response;
    } catch (error) {
      console.error('Erro ao buscar tarifas:', error);
      throw error;
    }
  }

  /**
   * Obtém componentes de tarifas para uma data específica
   * @param {string} dataRef - Data de referência (formato: YYYY-MM-DDTHH:mm:ss)
   * @returns {Promise} Response da API com componentes de tarifas
   */
  async getComponentes(dataRef) {
    try {
      const response = await api.get('/api/tarifas/componentes', {
        params: {
          DataRef: dataRef
        }
      });
      return response;
    } catch (error) {
      console.error('Erro ao buscar componentes de tarifas:', error);
      throw error;
    }
  }

  /**
   * Obtém dados de patamares de tarifas para uma data específica
   * @param {string} dataRef - Data de referência (formato: YYYY-MM-DDTHH:mm:ss)
   * @returns {Promise} Response da API com dados de patamares
   */
  async getPatamares(dataRef) {
    try {
      const response = await api.get('/api/tarifas/patamares', {
        params: {
          DataRef: dataRef
        }
      });
      return response;
    } catch (error) {
      console.error('Erro ao buscar patamares de tarifas:', error);
      throw error;
    }
  }

  /**
   * Obtém dados de bandeiras tarifárias para uma data específica
   * @param {string} dataRef - Data de referência (formato: YYYY-MM-DDTHH:mm:ss)
   * @returns {Promise} Response da API com dados de bandeiras
   */
  async getBandeiras(dataRef) {
    try {
      const response = await api.get('/api/tarifas/bandeiras', {
        params: {
          DataRef: dataRef
        }
      });
      return response;
    } catch (error) {
      console.error('Erro ao buscar bandeiras tarifárias:', error);
      throw error;
    }
  }
}

const tarifasService = new TarifasService();
export default tarifasService;
